import React from 'react';

import { ConfigProvider, Segmented } from 'antd';
import MergeClassNames from 'utils/MergeClassNames';

export interface PillSegmentedOption<T extends string | number> {
  label: React.ReactNode;
  value: T;
}

export interface PillSegmentedProps<T extends string | number> {
  options: PillSegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

const PILL_SEGMENTED_THEME = {
  components: {
    Segmented: {
      itemSelectedBg: 'var(--color-charcoal)',
      itemSelectedColor: 'var(--color-white)',
    },
  },
};

/**
 * Dark selected-pill Segmented for small toggles.
 * `self-start` stops flex-column stretch; `no-animation-segmented` removes the thumb lag.
 */
const PillSegmented = <T extends string | number>({
  options,
  value,
  onChange,
  className,
}: PillSegmentedProps<T>) => (
  <ConfigProvider theme={PILL_SEGMENTED_THEME}>
    <Segmented<T>
      className={MergeClassNames(
        'no-animation-segmented self-start text-sm font-semibold',
        className
      )}
      options={options}
      value={value}
      onChange={onChange}
    />
  </ConfigProvider>
);

export default PillSegmented;
